module.exports = __webpack_public_path__ + "static/mastercard-845526a9a8231ba6335fac9599b9fe4e.png";